import { MessageCircle } from "lucide-react";
import site, { waLink } from "@/config/site";

const WhatsAppFloat = () =>
  site.contact.whatsapp ? (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="animate-pulse-glow fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[var(--accent)] text-[#0A0F08] flex items-center justify-center hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  ) : null;

export default WhatsAppFloat;
